import { render, staticRenderFns } from "./loyalty-reward.vue?vue&type=template&id=3c2a50c0&scoped=true&"
import script from "./loyalty-reward.ts?vue&type=script&lang=ts&"
export * from "./loyalty-reward.ts?vue&type=script&lang=ts&"
import style0 from "./loyalty-reward.scss?vue&type=style&index=0&id=3c2a50c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a50c0",
  null
  
)

component.options.__file = "loyalty-reward.vue"
export default component.exports